import { RossService } from './ross.service';
import { Component, inject, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Match } from '../../_shared/models/match.model';
import { Clipboard } from '@capacitor/clipboard';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { ToastService } from '../../_core/services/toast.service';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-ross',
  templateUrl: './ross.component.html',
  styleUrls: ['./ross.component.scss'],
  standalone: true,
  imports: [IonicModule]
})

export class RossComponent  implements OnInit {
  rossService = inject(RossService);
  toastService = inject(ToastService);
  translateService = inject(TranslateService);

  @Input({required: true}) match!: Match;


  constructor() { }

  ngOnInit() {}

  async copyMatchId() {
    if (Capacitor.isNativePlatform()) {
      await Share.share({text: this.match._id});
    } else {
        Clipboard.write({ string: this.match._id });
        this.toastService.presentToast(this.translateService.instant('Link is copied to the the clipboard'))
    }
  }

  subscribe() {
    this.rossService.subscribeToMatch(this.match._id, 'ross').subscribe(res => this.match.scoreSubscribers.push('ross'))
  }

  unsubscribe() {
    this.rossService.unsubscribeFromMatch(this.match._id, 'ross').subscribe(res => this.match.scoreSubscribers = [])
  }

  isRossSubscribed(): boolean {
    return this.match.scoreSubscribers?.includes('ross')
  }

}
